import { getAll } from '@/utilities/querySelector';

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('htmx:afterSwap', init);

function init() {
    // Gives JS created buttons a chance before initting the buttons.
    requestAnimationFrame(() => {
        const buttons = /** @type {NodeListOf<HTMLElement>} */ (
            getAll('.button:not([data-circled])')
        );

        buttons.forEach((button) => {
            button.addEventListener('mousemove', handleMouseState);
            button.setAttribute('data-circled', '');
        });
    });
}

function handleMouseState(e) {
    const button = e.currentTarget;
    const isButtonHovered = button === e.target;
    let scale;

    if (isButtonHovered) {
        scale = {
            x: e.offsetX,
            y: e.offsetY,
        };
    } else {
        // Handle when the mousemoved target is a child of the button
        const rect = button.getBoundingClientRect();
        scale = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        };
    }

    e.currentTarget.style.setProperty(
        '--bg-position',
        `${scale.x}px ${scale.y}px 0px`,
    );
}
